// extracted by mini-css-extract-plugin
export default {"wrapper":"O1-z","play":"P1-z"};